/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { FormattedMessage } from 'react-intl';
import { Loading } from 'carbon-addons-iot-react';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import styles from './Logout.module.css';

import { useTimeout } from 'customHooks';
import * as userActionCreators from 'userActionCreators';

const propTypes = {
  ssoLogoutURL: PropTypes.string,
  redirectURL: PropTypes.string.isRequired,
  userActions: PropTypes.objectOf(PropTypes.func).isRequired,
};

const defaultProps = {
  ssoLogoutURL: null,
};

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(userActionCreators, dispatch),
});

const Logout = ({ redirectURL, userActions: { logoutCurrentUser }, ssoLogoutURL }) => {
  const [loggedOut, setLoggedOut] = useState(false);

  const redirectToTimeout = () => {
    logoutCurrentUser(ssoLogoutURL).then(() => {
      setLoggedOut(true);
      sessionStorage.clear();
      window.location.href = redirectURL;
    });
  };

  // Wait for 2 seconds so the user can read the logout message
  const handleLoggedOut = useTimeout(() => {
    redirectToTimeout();
  }, 2000);

  useEffect(
    () => {
      handleLoggedOut();
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <div className={styles.logout}>
      <h2>
        {loggedOut ? (
          <FormattedMessage defaultMessage="You are logged out. Redirecting you to the home screen." />
        ) : (
          <FormattedMessage defaultMessage="You are being logged out." />
        )}
      </h2>
      <Loading />
    </div>
  );
};

Logout.propTypes = propTypes;
Logout.defaultProps = defaultProps;
export default connect(null, mapDispatchToProps)(Logout);
